import { render, staticRenderFns } from "./BaseFacetteResult.vue?vue&type=template&id=c0f02312&scoped=true&"
import script from "./BaseFacetteResult.vue?vue&type=script&lang=js&"
export * from "./BaseFacetteResult.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=c0f02312&prod&scoped=true&lang=css&"
import style1 from "./BaseFacetteResult.vue?vue&type=style&index=1&id=c0f02312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f02312",
  null
  
)

export default component.exports